import { ResourceFragment } from '@/generated/contentful'

import { getBaseUrl } from '@/lib/contentful/utils'

import { getLocalizedFromEnglish } from '@/utils/locales/localized-routes/getLocalizedFromEnglish'

import { getResourcePageType } from './getResourcePageType'

const SUPPORTED_LOCALES: {
	locale: Locale
	slugKey: keyof ResourceFragment
	statusKey: keyof ResourceFragment
	hrefLang: string
}[] = [
	{ locale: 'en-US', slugKey: 'slug_en_US', statusKey: 'status_en_US', hrefLang: 'en-us' },
	{ locale: 'en-AU', slugKey: 'slug_en_AU', statusKey: 'status_en_AU', hrefLang: 'en-au' },
	{ locale: 'en-GB', slugKey: 'slug_en_GB', statusKey: 'status_en_GB', hrefLang: 'en-gb' },
	{ locale: 'fr-FR', slugKey: 'slug_fr_FR', statusKey: 'status_fr_FR', hrefLang: 'fr-fr' },
	{ locale: 'it-IT', slugKey: 'slug_it_IT', statusKey: 'status_it_IT', hrefLang: 'it-it' },
	{ locale: 'de-DE', slugKey: 'slug_de_DE', statusKey: 'status_de_DE', hrefLang: 'de-de' },
	{ locale: 'nl-NL', slugKey: 'slug_nl_NL', statusKey: 'status_nl_NL', hrefLang: 'nl-nl' },
	{ locale: 'es-ES', slugKey: 'slug_es_ES', statusKey: 'status_es_ES', hrefLang: 'es-es' },
	{ locale: 'es-MX', slugKey: 'slug_es_MX', statusKey: 'status_es_MX', hrefLang: 'es-mx' }
]

export const buildLanguageAlternates = (
	resource: ResourceFragment
): Array<{ hrefLang: string; href: string }> => {
	return SUPPORTED_LOCALES.reduce<{ hrefLang: string; href: string }[]>(
		(acc, { locale, slugKey, statusKey, hrefLang }) => {
			const localizedSlug = resource[slugKey]
			const isStatusEnabled = resource[statusKey]
			if (localizedSlug && isStatusEnabled) {
				acc.push({
					hrefLang,
					href: `${getBaseUrl(locale)}${getLocalizedFromEnglish(
						locale,
						`/resources/${getResourcePageType(resource.type)}/${localizedSlug}/`
					)}`
				})
			}
			return acc
		},
		[]
	)
}
